function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 0c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0 1.474A5.533 5.533 0 001.474 7 5.533 5.533 0 007 12.526 5.533 5.533 0 0012.526 7 5.533 5.533 0 007 1.474zm-.688 2.381c.407 0 .737.33.737.737v2.486h2.87a.737.737 0 010 1.474H6.312a.737.737 0 01-.737-.737V4.592c0-.407.33-.737.737-.737z",
  fill: "#B6B6B6",
  fillRule: "nonzero"
});

function SvgIconRecent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _ref);
}

export default SvgIconRecent;